/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Arjo API
 * OpenAPI spec version: v1
 */
import type {
  AssetLibrary,
  CrossPortalManager,
  FavoritePageItemModel,
  FavoritePageListModel,
  GetApiCrossportalmanagerAllLanguageSelectorParams,
  GetApiCrossportalmanagerInitParams,
  GetApiMyarjofavouriteGetParams,
  GetApiMyarjofavouriteIsfavoriteParams,
  GetApiMyarjofavouriteListParams,
  GetApiMyarjofavouriteextendGetParams,
  GetApiMyarjofavouriteextendIsfavoriteParams,
  GetApiMyarjofavouriteextendListParams,
  GetApiWebinarapiParams,
  LocaleSelectorData,
  NewFavourite,
  PrivacyFormSubmitRequest,
  QueryParameters,
  UpdateFavourite,
} from '../_schema';
import { sendAsync } from '../_base';

export const postApiAssetsdownloadSearch = (queryParameters: QueryParameters) => {
  return sendAsync<AssetLibrary>({
    url: `/api/assetsdownload/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: queryParameters,
  });
};

export const getApiCrossportalmanagerInit = (params?: GetApiCrossportalmanagerInitParams) => {
  return sendAsync<CrossPortalManager>({ url: `/api/crossportalmanager/init`, method: 'GET', params });
};

export const getApiCrossportalmanagerAllLanguageSelector = (params?: GetApiCrossportalmanagerAllLanguageSelectorParams) => {
  return sendAsync<LocaleSelectorData>({ url: `/api/crossportalmanager/all-language-selector`, method: 'GET', params });
};

export const postApiCrossportalmanagerSubmitPrivacy = (privacyFormSubmitRequest: PrivacyFormSubmitRequest) => {
  return sendAsync<string>({
    url: `/api/crossportalmanager/submit-privacy`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: privacyFormSubmitRequest,
  });
};

export const postApiCrossportalmanagerSubmitPrivacyMyarjo = (privacyFormSubmitRequest: PrivacyFormSubmitRequest) => {
  return sendAsync<string>({
    url: `/api/crossportalmanager/submit-privacy-myarjo`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: privacyFormSubmitRequest,
  });
};

export const getApiMyarjofavouriteList = (params?: GetApiMyarjofavouriteListParams) => {
  return sendAsync<FavoritePageListModel>({ url: `/api/myarjofavourite/list`, method: 'GET', params });
};

export const deleteApiMyarjofavouriteId = (id: number) => {
  return sendAsync<boolean>({ url: `/api/myarjofavourite/${id}`, method: 'DELETE' });
};

export const getApiMyarjofavouriteIsfavorite = (params?: GetApiMyarjofavouriteIsfavoriteParams) => {
  return sendAsync<unknown>({ url: `/api/myarjofavourite/isfavorite`, method: 'GET', params });
};

export const getApiMyarjofavouriteGet = (params?: GetApiMyarjofavouriteGetParams) => {
  return sendAsync<FavoritePageItemModel>({ url: `/api/myarjofavourite/get`, method: 'GET', params });
};

export const postApiMyarjofavouriteCreate = (newFavourite: NewFavourite) => {
  return sendAsync<FavoritePageItemModel>({
    url: `/api/myarjofavourite/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: newFavourite,
  });
};

export const putApiMyarjofavouriteUpdate = (updateFavourite: UpdateFavourite) => {
  return sendAsync<FavoritePageItemModel>({
    url: `/api/myarjofavourite/update`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: updateFavourite,
  });
};

export const postApiMyarjofavouriteextendCreate = (newFavourite: NewFavourite) => {
  return sendAsync<FavoritePageItemModel>({
    url: `/api/myarjofavouriteextend/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: newFavourite,
  });
};

export const getApiMyarjofavouriteextendList = (params?: GetApiMyarjofavouriteextendListParams) => {
  return sendAsync<FavoritePageListModel>({ url: `/api/myarjofavouriteextend/list`, method: 'GET', params });
};

export const deleteApiMyarjofavouriteextendId = (id: number) => {
  return sendAsync<boolean>({ url: `/api/myarjofavouriteextend/${id}`, method: 'DELETE' });
};

export const getApiMyarjofavouriteextendIsfavorite = (params?: GetApiMyarjofavouriteextendIsfavoriteParams) => {
  return sendAsync<unknown>({ url: `/api/myarjofavouriteextend/isfavorite`, method: 'GET', params });
};

export const getApiMyarjofavouriteextendGet = (params?: GetApiMyarjofavouriteextendGetParams) => {
  return sendAsync<FavoritePageItemModel>({ url: `/api/myarjofavouriteextend/get`, method: 'GET', params });
};

export const putApiMyarjofavouriteextendUpdate = (updateFavourite: UpdateFavourite) => {
  return sendAsync<FavoritePageItemModel>({
    url: `/api/myarjofavouriteextend/update`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json-patch+json' },
    data: updateFavourite,
  });
};

export const getApiWebinarapi = (params?: GetApiWebinarapiParams) => {
  return sendAsync<void>({ url: `/api/webinarapi`, method: 'GET', params });
};

export type PostApiAssetsdownloadSearchResult = NonNullable<Awaited<ReturnType<typeof postApiAssetsdownloadSearch>>>;
export type GetApiCrossportalmanagerInitResult = NonNullable<Awaited<ReturnType<typeof getApiCrossportalmanagerInit>>>;
export type GetApiCrossportalmanagerAllLanguageSelectorResult = NonNullable<Awaited<ReturnType<typeof getApiCrossportalmanagerAllLanguageSelector>>>;
export type PostApiCrossportalmanagerSubmitPrivacyResult = NonNullable<Awaited<ReturnType<typeof postApiCrossportalmanagerSubmitPrivacy>>>;
export type PostApiCrossportalmanagerSubmitPrivacyMyarjoResult = NonNullable<
  Awaited<ReturnType<typeof postApiCrossportalmanagerSubmitPrivacyMyarjo>>
>;
export type GetApiMyarjofavouriteListResult = NonNullable<Awaited<ReturnType<typeof getApiMyarjofavouriteList>>>;
export type DeleteApiMyarjofavouriteIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiMyarjofavouriteId>>>;
export type GetApiMyarjofavouriteIsfavoriteResult = NonNullable<Awaited<ReturnType<typeof getApiMyarjofavouriteIsfavorite>>>;
export type GetApiMyarjofavouriteGetResult = NonNullable<Awaited<ReturnType<typeof getApiMyarjofavouriteGet>>>;
export type PostApiMyarjofavouriteCreateResult = NonNullable<Awaited<ReturnType<typeof postApiMyarjofavouriteCreate>>>;
export type PutApiMyarjofavouriteUpdateResult = NonNullable<Awaited<ReturnType<typeof putApiMyarjofavouriteUpdate>>>;
export type PostApiMyarjofavouriteextendCreateResult = NonNullable<Awaited<ReturnType<typeof postApiMyarjofavouriteextendCreate>>>;
export type GetApiMyarjofavouriteextendListResult = NonNullable<Awaited<ReturnType<typeof getApiMyarjofavouriteextendList>>>;
export type DeleteApiMyarjofavouriteextendIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiMyarjofavouriteextendId>>>;
export type GetApiMyarjofavouriteextendIsfavoriteResult = NonNullable<Awaited<ReturnType<typeof getApiMyarjofavouriteextendIsfavorite>>>;
export type GetApiMyarjofavouriteextendGetResult = NonNullable<Awaited<ReturnType<typeof getApiMyarjofavouriteextendGet>>>;
export type PutApiMyarjofavouriteextendUpdateResult = NonNullable<Awaited<ReturnType<typeof putApiMyarjofavouriteextendUpdate>>>;
export type GetApiWebinarapiResult = NonNullable<Awaited<ReturnType<typeof getApiWebinarapi>>>;
